//Import required libraries
import React, { useState, useEffect } from 'react';

//Import custom components
import Header from '../components/common/header/Header'
import Navigation from '../components/photographer/navigation/Navigation'
import Content from '../components/photographer/content/Content'

//Import Utils
import { isElementEvenPartlyInViewport } from '../utils/utils'

//Import Styles

const Photographer = () => {

  const [catSelected, setCatSelected] = useState('Home')
  const [navSticky, setNavSticky] = useState(false)
  const [showNav, setShowNav] = useState(false)

  //Scroll function for navbar
  // useEffect(() => {
  //   const handleScroll = () => {
  //       setShowNav(false)
  //       let header = document.getElementById("header");
  //       if (header) {
  //           setNavSticky(!isElementEvenPartlyInViewport(header))
  //       }
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //       window.removeEventListener('scroll', handleScroll);
  //   }
  // }, [false])

  return (
    <>
      <Header navSticky={true} pagesFlag={true}/>
      <Navigation catSelected={catSelected} 
                  setCatSelected={setCatSelected} 
                  navSticky={true}
                  showNav={true}
                  setShowNav={setShowNav}/>
      <Content catSelected={catSelected} 
                setCatSelected={setCatSelected}/>
    </>
  );
}

export default Photographer;
